<mat-toolbar class="subtitulo">Saldos de contas bancárias</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formulario="ngForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>

                <mat-form-field fxFlex="25%" fxFlexOffset="20px">
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label fxFlexOffset="20px">Selecione um tipo</mat-label>
                    <mat-select fxFlexOffset="20px"
                                [(ngModel)]="filter.tipoContaBancaria" 
                                (selectionChange)="filtrarContasPorTipo()"
                                name="tipoContaBancaria">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of tiposContas" [value]="d.tipo">
                            {{d.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field fxFlex="75%" >
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label fxFlexOffset="20px">Selecione um Banco/Agência/Conta</mat-label>
                    <mat-select fxFlexOffset="20px"
                                [(ngModel)]="filter.idContaBancaria" 
                                name="banco" 
                                [disabled]="!filter.tipoContaBancaria">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of bancos" [value]="d.idConta">
                            Banco: {{d.banco.numero}} - {{d.banco.nome}} - Agência: {{d.numeroAgencia}} - Conta: {{d.numeroContaBancaria}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

            </div>

          
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <mat-icon fxFlexOffset="20px" matPrefix>search</mat-icon>
                <mat-form-field fxFlex= "130px" >
                    <input matInput name= "dataInicio"
                           [matDatepicker]="dataInicio" 
                           placeholder="Data Início" 
                           [(ngModel)]="filter.dataInicio"
                           required>
                    <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicio></mat-datepicker>
                </mat-form-field>
            
                <mat-icon matPrefix>search</mat-icon>
                <mat-form-field fxFlex= "130px" >
                    <input matInput name= "dataFim"
                           [matDatepicker]="dataFim" 
                           placeholder="Data Fim" 
                           [(ngModel)]="filter.dataFim"
                           required>
                    <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                    <mat-datepicker #dataFim></mat-datepicker>
                </mat-form-field>
            </div>
            

            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()" [disabled]="formulario.invalid">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

    </div>
</div>
